export default __webpack_public_path__ + "static/media/group-member-select.301a1077.svg";